import React from 'react';
import './AiTest.scss';

const AiTest = () => {
  const cards = [
    {
      id: 1,
      title: '校园消防安全应急事件应急事件',
      description: '为你生成一个校园消防安全应急事件的案例',
      color: 'card-blue'
    },
    {
      id: 2,
      title: '校园消防安全应急事件校园消防应急事件',
      description: '为生成一个校园消防安全应急事件的案例',
      color: 'card-lightblue'
    },
    {
      id: 3,
      title: '小孩晚上玩手机不睡觉问题处理',
      description: '为你生成一个校园消防安全应急事件的案例',
      color: 'card-purple'
    },
    {
      id: 4,
      title: '校园消防安全应急事件应急事件',
      description: '为你生成一个校园消防安全应急事件的案例',
      color: 'card-green'
    },
    {
      id: 5,
      title: '校园消防安全应急事件应急事件',
      description: '为你生成一个校园消防安全应急事件的案例',
      color: 'card-yellow'
    },
    {
      id: 6,
      title: '思源中学食堂学生集体中毒事件',
      description: '为你生成一个校园消防安全应急事件的案例',
      color: 'card-pink'
    }
  ];

  return (
    <div className="ai-test-container">
      <div className="card-grid">
        {cards.map(card => (
          <div key={card.id} className={`card ${card.color}`}>
            <div className="card-icon">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 1L15 8L8 15L1 8L8 1Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="card-number">0{card.id}</div>
            <h3 className="card-title">{card.title}</h3>
            <p className="card-description">{card.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AiTest;
